// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pmadvancespg-inline-1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.pmadvancespg-inline-2 {
  margin-bottom: 0;
}

.pmadvancespg-inline-3 {
  padding: 0;
  overflow-x: auto;
}

.pmadvancespg-inline-4 {
  font-family: monospace;
  font-size: 11px;
}

.pmadvancespg-inline-5 {
  font-weight: 600;
}

.pmadvancespg-inline-6 {
  max-width: 280px;
  font-size: 11px;
}

.pmadvancespg-inline-7 {
  display: flex;
  gap: 6px;
}

.pmadvancespg-dyn-1 {
  text-align: center;
  padding: 30px;
  color: var(--pmadvancespg-1-color);
}

.pmadvancespg-dyn-2 {
  text-align: center;
  padding: 30px;
  color: var(--pmadvancespg-2-color);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/PM/PMAdvancesPg.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kCAAkC;AACpC","sourcesContent":[".pmadvancespg-inline-1 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.pmadvancespg-inline-2 {\n  margin-bottom: 0;\n}\n\n.pmadvancespg-inline-3 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.pmadvancespg-inline-4 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.pmadvancespg-inline-5 {\n  font-weight: 600;\n}\n\n.pmadvancespg-inline-6 {\n  max-width: 280px;\n  font-size: 11px;\n}\n\n.pmadvancespg-inline-7 {\n  display: flex;\n  gap: 6px;\n}\n\n.pmadvancespg-dyn-1 {\n  text-align: center;\n  padding: 30px;\n  color: var(--pmadvancespg-1-color);\n}\n\n.pmadvancespg-dyn-2 {\n  text-align: center;\n  padding: 30px;\n  color: var(--pmadvancespg-2-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
